import {MoreDetailsLeftCornerCipBox} from "./more-details-left-corner.casino888.cip.box";

export const MoreDetailsLeftCornerCisBox = MoreDetailsLeftCornerCipBox